import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { ArrowButton } from '../ui/ArrowButton';
import { Reveal } from '../ui/Reveal';
import { SectionLabel } from '../ui/SectionLabel';
import { SplitText } from '../ui/SplitText';
import { caseStudies } from '../../data/caseStudies';
export function CaseStudiesSection() {
  const [featured, ...others] = caseStudies;
  const secondary = others.slice(0, 2);
  return <section className="bg-white py-24 lg:py-36" data-id="element-101" data-mp="2vhkxxff3ixnq">
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8" data-id="element-102" data-mp="2qhqaxmyfys7y">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between" data-id="element-103" data-mp="2lpozu4d0f7ji">
          <div data-id="element-104" data-mp="2gqvlk9pwfcia">
            <Reveal data-id="element-105" data-mp="2grdpztmpsx1a">
              <SectionLabel data-id="element-106" data-mp="2gpua444z0o01">Références</SectionLabel>
            </Reveal>
            <h2 className="mt-6 max-w-2xl text-[clamp(2rem,4vw,3.25rem)] font-medium leading-[1.08] tracking-[-0.03em]" data-id="element-107" data-mp="3e5zra9cvynrp">
              <SplitText text="Des missions qui ont fait la différence." data-id="element-108" data-mp="39ehzobwr5zje" />
            </h2>
          </div>
          <Reveal delay={0.1} data-id="element-109" data-mp="g8qbso56xljj">
            <ArrowButton to="/references" data-id="element-110" data-mp="g9ryxqzhdyhm">Toutes les références</ArrowButton>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-6 lg:grid-cols-12" data-id="element-111" data-mp="kb3fl70dn9do">
          <Reveal className="lg:col-span-7" data-id="element-112" data-mp="6h2p10jkwsoe">
            <Link to="/references" className="group relative isolate flex min-h-[520px] flex-col justify-end overflow-hidden rounded-[28px] p-6 text-white sm:p-10 lg:h-full" data-id="element-113" data-mp="6g1agm3cto1x">
              <img src={featured.image} alt="" className="absolute inset-0 -z-20 h-full w-full object-cover transition-transform duration-300 ease-out-strong group-hover:scale-[1.04]" data-id="element-114" data-mp="1ij493gq1mxm" />
              <div className="absolute inset-0 -z-10 bg-ink/60" data-id="element-115" data-mp="3oo0iyanxtgy6" />
              <div className="flex flex-wrap gap-2 text-sm" data-id="element-116" data-mp="1hwrbzrwu1rp7">
                <span className="rounded-md bg-white/15 px-3 py-1.5 backdrop-blur-sm" data-id="element-117" data-mp="1hv6j06q62gtg">{featured.sector}</span>
                <span className="rounded-md bg-white/15 px-3 py-1.5 backdrop-blur-sm" data-id="element-118" data-mp="1khgztlunqgmf">{featured.duration}</span>
              </div>
              <h3 className="mt-5 max-w-xl text-[clamp(1.6rem,2.6vw,2.25rem)] font-medium leading-tight tracking-tight" data-id="element-119" data-mp="1gflw6ap97r5h">
                {featured.title}
              </h3>
              <div className="mt-8 flex flex-wrap items-end justify-between gap-6 border-t border-white/20 pt-6" data-id="element-120" data-mp="16hxqipq40z8j">
                <dl className="flex gap-10" data-id="element-121" data-mp="245y6ttbvw1zr">
                  {featured.results.map(r => <div key={r.label} data-id="element-122" data-mp="1z5tnlvjlct5u">
                      <dt className="sr-only" data-id="element-123" data-mp="1z6v6gm6umjy4">{r.label}</dt>
                      <dd className="text-3xl font-medium text-brass" data-id="element-124" data-mp="1uf3jelmwiwcq">{r.value}</dd>
                      <dd className="text-sm text-white/70" data-id="element-125" data-mp="1pgtj5wmbl5k9">{r.label}</dd>
                    </div>)}
                </dl>
                <span className="grid h-11 w-11 place-items-center rounded-full bg-white text-ink transition-transform duration-200 ease-out-strong group-hover:rotate-45" aria-hidden="true" data-id="element-126" data-mp="2mwpjp4v2yaiw">
                  <ArrowUpRightIcon className="h-5 w-5" data-id="element-127" data-mp="2phf74xozsxfl" />
                </span>
              </div>
            </Link>
          </Reveal>

          <div className="grid gap-6 lg:col-span-5" data-id="element-128" data-mp="2uhjf1zbu4ju7">
            {secondary.map((cs, i) => <Reveal key={cs.slug} delay={0.08 * (i + 1)} data-id="element-129" data-mp="2zgmkhkvq8s2p" data-mpi={i}>
                <Link to="/references" className="group grid h-full gap-5 rounded-[28px] bg-paper p-3 transition-colors duration-200 hover:bg-mist sm:grid-cols-[180px_1fr]" data-id="element-130" data-mp="34eo17z5okfb0">
                  <div className="aspect-[4/3] overflow-hidden rounded-[20px] sm:aspect-auto sm:h-full" data-id="element-131" data-mp="3dchxja3g38y6">
                    <img src={cs.image} alt="" className="h-full w-full object-cover transition-transform duration-300 ease-out-strong group-hover:scale-[1.06]" data-id="element-132" data-mp="3i5t377witjoi" />
                  </div>
                  <div className="flex flex-col p-3 sm:py-4 sm:pl-0 sm:pr-4" data-id="element-133" data-mp="7rpxq6hd2g">
                    <p className="text-sm text-muted" data-id="element-134" data-mp="xnhrl0pfu8fm">{cs.sector}</p>
                    <h3 className="mt-2 text-xl font-medium leading-snug tracking-tight" data-id="element-135" data-mp="sp7vmnvw33sy">{cs.title}</h3>
                    <div className="mt-auto flex items-baseline gap-2 pt-6" data-id="element-136" data-mp="16gla3nexxbh4">
                      <span className="text-2xl font-medium text-brass-dark" data-id="element-137" data-mp="16ipc1zta40er">{cs.results[0].value}</span>
                      <span className="text-sm text-muted" data-id="element-138" data-mp="12hdm1t6htd61">{cs.results[0].label}</span>
                    </div>
                  </div>
                </Link>
              </Reveal>)}
          </div>
        </div>
      </div>
    </section>;
}